import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdatePaymentMethodMutation = ({ onSuccess, submitService }) => {
	const dispatch = useDispatch();

	return useMutation(submitService, {
		onMutate() {
			dispatch(uiActions.showSpinnerOverlay());
		},
		onSuccess() {
			dispatch(
				uiActions.showSuccessNotification({
					title: "Payment Method has been successfully updated",
				}),
			);
			onSuccess?.();
		},
		onError(error: ErrorResponse) {
			dispatch(
				uiActions.showErrorNotification({
					title: getErrorMessage(error),
				}),
			);
		},
		onSettled() {
			dispatch(uiActions.hideSpinnerOverlay());
		},
	});
};

export default useUpdatePaymentMethodMutation;
